var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "129px",
    viewBox: "0 0 129 129",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Success",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Alert/Orange",
    fill: "#246B47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4355,0 C28.8315,0 0,28.896 0,64.5 C0,100.104 28.8315,129 64.4355,129 C100.104,129 129,100.104 129,64.5 C129,28.896 100.104,0 64.4355,0 L64.4355,0 Z M13,64.5 C13,36.04625 36.04625,13 64.5,13 C92.95375,13 116,36.04625 116,64.5 C116,92.95375 92.95375,116 64.5,116 C36.04625,116 13,92.95375 13,64.5 Z",
    id: "Icon/Material-Design/Alert---Orange"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-solid",
    transform: "translate(35.000000, 42.000000)",
    fill: "#246B47",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3786625,43.1358415 L0.878643436,23.959529 C-0.292881145,22.8074521 -0.292881145,20.9394903 0.878643436,19.7872981 L5.12118664,15.6150673 C6.29271122,14.4628751 8.19232245,14.4628751 9.36384704,15.6150673 L22.5,28.5330334 L50.636153,0.864057674 C51.8076775,-0.288019225 53.7072888,-0.288019225 54.8788134,0.864057674 L59.1213566,5.03628854 C60.2928811,6.18836544 60.2928811,8.05632727 59.1213566,9.20851942 L24.6213229,43.1359567 C23.4496811,44.2880336 21.5501871,44.2880336 20.3786625,43.1358415 L20.3786625,43.1358415 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.a261ec33aa633c7a26c0b9903c6c2810.svg";
export { ForwardRef as ReactComponent };